export class Step2 {
	public intitule = 'stepper.form.simp_in.step2';

	public getoui = 'form.simp_in.getoui';
	public getnon = 'form.simp_in.getnon';
	public getspan7 = 'form.simp_in.getspan7';
	public getspan8 = 'form.simp_in.getspan8';
	public getspan9 = 'form.simp_in.getspan9';
	public getspan10 = 'form.simp_in.getspan10';
	public getspan11 = 'form.simp_in.getspan11';
	public getspan12 = 'form.simp_in.getspan12';
	public getspan13 = 'form.simp_in.getspan13';
	public getspan14 = 'form.simp_in.getspan14';
	public getspan15 = 'form.simp_in.getspan15';
	public getspan16 = 'form.simp_in.getspan16';

	public procedureAdapteeO = 'form.simp_in.getprocedureadapteeo';
	public procedureAdapteeR = 'form.simp_in.getprocedureadapteer';
	public capaciteExercice = 'form.simp_in.getcapaciteexercice';
	public capaciteEcoFin = 'form.simp_in.getcapaciteecofin';
	public capaciteTech = 'form.simp_in.getcapacitetech';
	public accordCadre = 'form.simp_in.getaccordcadre';
	public sysQuali = 'form.simp_in.getsysquali';
	public sad = 'form.simp_in.getsad';
	public concours = 'form.simp_in.getconcours';
	public catalogueElec = 'form.simp_in.getcatalogueelec';
	public enchereElec = 'form.simp_in.getenchereelec';
	public autres = 'form.simp_in.getautres';
	public dateReceptionOffres = 'form.simp_in.getdatereceptionoffres';
	public exigee = 'form.simp_in.getexigee';
	public autorisee = 'form.simp_in.getautorisee';
	public interdite = 'form.simp_in.getinterdite';
	public criteres = 'form.simp_in.getcriteres';
	public nbCandidat = 'form.simp_in.getnbcandidat';
	public categorieAcheteur = 'form.simp_in.getcategorieacheteur';
	public criteresAttrib = 'form.simp_in.getcriteresattrib';

	constructor() {}
}
